import React from 'react';
import { authRoles } from 'app/auth';

export const WatsonxConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Any signed-in role can be federated to IBM Cloud; the api decides whether
	// the user's organization has watsonx single sign-on.
	auth: authRoles.anyAuthenticated,
	routes: [
		{
			// AI & Data > watsonx.ai: catalog + playground inside Heidi.
			path: '/watsonx/models',
			exact: true,
			component: React.lazy(() => import('./WatsonxModels'))
		},
		{
			// AI & Data > watsonx.data: lakehouse browser + read-only SQL inside Heidi.
			path: '/watsonx/data',
			exact: true,
			component: React.lazy(() => import('./WatsonxData'))
		},
		{
			// AI & Data > watsonx Orchestrate: agents + agent chat inside Heidi.
			path: '/watsonx/workflows',
			exact: true,
			component: React.lazy(() => import('./WatsonxWorkflows'))
		},
		{
			path: '/watsonx/sso/:request',
			component: React.lazy(() => import('./WatsonxSso'))
		},
		{
			// Sidebar "AI & Data" items open here in a new tab, which then posts
			// the signed sign-in to IBM Cloud from that same tab.
			path: '/watsonx/open/:target',
			component: React.lazy(() => import('./WatsonxOpen'))
		}
	]
};
